import { FC, useRef } from 'react';
import { ExperienceAnswerStep } from 'shared/models';
import { ListWrapper } from '../answer-list-wrapper';
import { AnswerStepContent } from '../answer-step-content';

import './style.scss';

interface FullAnswerBodyProps {
  stepContent: ExperienceAnswerStep[];
  isNumber: boolean;
}

export const FullAnswerBody: FC<FullAnswerBodyProps> = (props) => {
  const { stepContent, isNumber } = props;
  const fullAnswerRef = useRef<HTMLDivElement>(null);

  return (
    <div className="full-answer-body" ref={fullAnswerRef}>
      <ListWrapper isNumber={isNumber}>
        {stepContent.map((step, index) => {
          return (
            <AnswerStepContent key={index} title={step.title} content={step.content} sourceList={step.sourceList} />
          );
        })}
      </ListWrapper>
    </div>
  );
};
